/***************************************************************************
 * The contents of this file were generated with Amplify Studio.           *
 * Please refrain from making any modifications to this file.              *
 * Any changes to this file will be overwritten when running amplify pull. *
 **************************************************************************/

/* eslint-disable */
import * as React from "react";
import { getOverrideProps } from "@aws-amplify/ui-react/internal";
import { Icon, Text, View } from "@aws-amplify/ui-react";
export default function QuestionItemHead(props) {
  const { questionBase, overrides, ...rest } = props;
  return (
    <View
      width="664px"
      height="189px"
      display="block"
      gap="unset"
      alignItems="unset"
      justifyContent="unset"
      overflow="hidden"
      position="relative"
      padding="0px 0px 0px 0px"
      backgroundColor="rgba(255,255,255,1)"
      {...getOverrideProps(overrides, "QuestionItemHead")}
      {...rest}
    >
      <Icon
        width="664px"
        height="96px"
        viewBox={{ minX: 0, minY: 0, width: 664, height: 96 }}
        paths={[
          {
            d: "M0 48L664 48L664 96L0 96L0 48Z",
            fill: "rgba(209,112,145,1)",
            fillRule: "nonzero",
          },
        ]}
        display="block"
        gap="unset"
        alignItems="unset"
        justifyContent="unset"
        position="absolute"
        top="17px"
        left="0px"
        {...getOverrideProps(overrides, "Rectangle 25")}
      ></Icon>
      <Text
        fontFamily="Inter"
        fontSize="16px"
        fontWeight="700"
        color="rgba(205,112,143,1)"
        lineHeight="22px"
        textAlign="center"
        display="block"
        direction="column"
        justifyContent="unset"
        width="unset"
        height="unset"
        gap="unset"
        alignItems="unset"
        position="absolute"
        top="30px"
        left="164px"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children="あなたに合った教材や仲間をマッチングします"
        {...getOverrideProps(overrides, "text39455120")}
      ></Text>
      <Text
        fontFamily="Inter"
        fontSize="30px"
        fontWeight="500"
        color="rgba(0,0,0,1)"
        lineHeight="22px"
        textAlign="center"
        display="block"
        direction="column"
        justifyContent="unset"
        letterSpacing="-0.45px"
        width="664px"
        height="38px"
        gap="unset"
        alignItems="unset"
        position="absolute"
        top="141px"
        left="7px"
        padding="0px 0px 0px 0px"
        whiteSpace="pre-wrap"
        children={questionBase?.QBase}
        {...getOverrideProps(overrides, "text39455121")}
      ></Text>
    </View>
  );
}
